type Props = {
  text: string;
  size?: 'large' | 'medium' | 'small';
  variant?: 'primary' | 'secondary' | 'default';
};

export const SectionTitle = ({
  text,
  size = 'large',
  variant = 'primary',
}: Props) => {
  const sizeClasses = {
    large: 'text-[18px] noto-sans-jp-bold',
    medium: 'text-[16px] noto-sans-jp-medium',
    small: 'text-[14px] noto-sans-jp-medium',
  };

  const variantClasses = {
    primary: 'text-primary',
    secondary: 'text-textSecondary',
    default: 'text-gray-700',
  };

  return (
    <p className={`${sizeClasses[size]} ${variantClasses[variant]}`}>{text}</p>
  );
};
